import React from 'react';
import { useSelector } from 'react-redux';

export default function Page404() {
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const navbarCategory = useSelector(({ navigation }) => navigation.navbarCategory);
    const wording = useSelector(({ language }) => language.wording);

    return (
        <>
            <section style={{ backgroundColor: '#7e7e7e', paddingTop: 20, paddingBottom: 20 }}>
                <div className='container relative clearfix'>
                    <ol className='breadcrumb'>
                        <li>
                            <a href='/'>
                                {currentLanguage === 'TH'
                                    ? navbarCategory[0].categoriesNameTh
                                    : navbarCategory[0].categoriesNameEn}
                            </a>
                        </li>

                        <li className='active uppercase'>{wording.notFoundPage.title}</li>
                    </ol>
                </div>
            </section>

            <section className='section-wrap-sm'>
                <div className='container'>
                    <div className='row text-center'>
                        <div className='col-md-10 col-md-offset-1'>
                            <div className='icon-warpper'>
                                <img src='/assets/img/sf/not-found.png' alt='not-found.png' />
                            </div>
                            <h1 className='uppercase'>{wording.notFoundPage.bodyMessage}</h1>
                            <p className='white'>
                                {wording.notFoundPage.urlMessage1} <a href='/'>{wording.notFoundPage.urlMessage2}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
